export enum RoomType {
	KITCHEN = 'kitchen',
	/* @deprecated */ BATH = "bath",
	BATHROOM = "bath",
	PARTS = 'parts'
}



// WEBPACK FOOTER //
// ./js/PFF/angular-modules/common/interfaces/RoomType.ts